import { render, staticRenderFns } from "./administration.vue?vue&type=template&id=6f952faf&scoped=true"
import script from "./administration.vue?vue&type=script&lang=js"
export * from "./administration.vue?vue&type=script&lang=js"
import style0 from "./administration.vue?vue&type=style&index=0&id=6f952faf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f952faf",
  null
  
)

export default component.exports